const map = {
	"./affiliations.js": 72020,
	"./aiCoding.js": 31019,
	"./articleAssignmentRules.js": 32793,
	"./articleGroup.js": 14958,
	"./articleOrganizationScore.js": 45926,
	"./articles.js": 13928,
	"./articlesByUrls.js": 52011,
	"./authors.js": 24703,
	"./briefMappings.js": 79756,
	"./briefings.js": 24234,
	"./carmaAi.js": 20385,
	"./carmaAiFiltration.js": 52375,
	"./carmaAiSummaries.js": 25693,
	"./clientDataApi.js": 15830,
	"./coders.js": 91837,
	"./countries.js": 80525,
	"./countrySubscription.js": 48132,
	"./editorCountries.js": 85482,
	"./editorOutlet.js": 64443,
	"./editorOutlets.js": 82158,
	"./index.js": 46515,
	"./influencerGroups.js": 65652,
	"./languages.js": 60504,
	"./mediaClipper.js": 2770,
	"./mediaTypes.js": 53398,
	"./mobileApp.js": 26794,
	"./organizations.js": 67875,
	"./outletGroups.js": 4666,
	"./projectSetup.js": 52337,
	"./projects.js": 55645,
	"./queries.js": 5919,
	"./regions.js": 35134,
	"./relevancy.js": 17732,
	"./source.js": 64942,
	"./sourceCategories.js": 11550,
	"./sources.js": 62917,
	"./tag.js": 88071,
	"./tagShare.js": 9112,
	"./tags.js": 17234,
	"./user.js": 12296,
	"./whatsapp.js": 81553
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78043;